module.exports = __webpack_public_path__ + "img/levelup-products-courses.e386bb3e.svg";